// action constatns for website management Files
export const SET_MULTIMEDIA_DATA = "SET_MULTIMEDIA_DATA";
export const SET_FILES_DATA = "SET_FILES_DATA";
